import assignBox from './assignBox';
import changeViewDropdown from './changeViewDropdown';
import dataExport from './dataExport';
import dataUpload from './dataUpload';
import dualList from './dualList';
import feedbackCard from './feedbackCard';
import history from './history';
import kpi from './kpi';
import mapLayers from './mapLayers';
import vehicleMarkerPopup from './vehicleMarkerPopup';

const index = {
  assignBox,
  history,
  kpi,
  dataExport,
  dataUpload,
  vehicleMarkerPopup,
  mapLayers,
  dualList,
  changeViewDropdown,
  feedbackCard,
};

export default index;
